// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-text-field div.v-input__slot{background-color:#fff!important;border-radius:var(--v-border-radius)}.contact-links a.contact-links--link{color:rgba(0,0,0,.6);-webkit-text-decoration:none;text-decoration:none}.contact-links a.contact-links--link:hover{color:rgba(0,0,0,.87)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
